module.exports = __webpack_public_path__ + "img/product-shot_04.8980046a.jpg";